'use client';
import Image from 'next/image';

const speakers = [

  {
    name: "Jaeyun Noh",
    designation: "CEO",
    company: "Indie Fun & Modd.io",
    imageSrc: "/images/speakers/jaeyun-noh.webp",
    alt: "jaeyun-noh",
  },

  {
    name: "Geronimo Martorelli",
    designation: "CEO",
    company: "Valannia",
    imageSrc: "/images/speakers/gero-vallania.webp",
    alt: "gero-vallania",
  },
  {
    name: "Simon Vieira Ramirez",
    designation: "Founder",
    company: "MixMob",
    imageSrc: "/images/speakers/simon.webp",
    alt: "simon",
  },
  {
    name: "Ryan Tjhin",
    designation: "Co-founder & CMO",
    company: "Crypto Fantasy League",
    imageSrc: "/images/speakers/riyan.webp",
    alt: "riyan",
  },
  {
    name: "Lionel Williams",
    designation: "Vice President",
    company: "Lightnode Ventures",
    imageSrc: "/images/speakers/lionel-willians.webp",
    alt: "lionel-willians",
  },
];

const SpeakerSection = () => {
  return (
    <section data-component-id="src/app/NewSpeakersSection.tsx:46:4" data-component-path="src/app/NewSpeakersSection.tsx" data-component-line="46" data-component-file="NewSpeakersSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22speakers%22%2C%22className%22%3A%22w-full%20p-6%20sm%3Ap-8%20md%3Ap-10%20lg%3Ap-%5B38px%5D%20items-center%20justify-center%22%7D"
      id="speakers"
      className="w-full p-6 sm:p-8 md:p-10 lg:p-[38px] items-center justify-center"  
    >
      <div data-component-id="src/app/NewSpeakersSection.tsx:50:6" data-component-path="src/app/NewSpeakersSection.tsx" data-component-line="50" data-component-file="NewSpeakersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1540px%5D%22%7D" className="w-full max-w-[1540px]">
        <h2 data-component-id="src/app/NewSpeakersSection.tsx:51:8" data-component-path="src/app/NewSpeakersSection.tsx" data-component-line="51" data-component-file="NewSpeakersSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B32px%5D%20sm%3Atext-%5B38px%5D%20md%3Atext-%5B42px%5D%20lg%3Atext-%5B48px%5D%20font-bold%20leading-tight%20text-center%20text-text-white%20mb-10%22%2C%22textContent%22%3A%22Past%20Speakers%22%7D" className="text-[32px] sm:text-[38px] md:text-[42px] lg:text-[48px] font-bold leading-tight text-center text-text-white mb-10"
              style={{ fontFamily: 'Gemunu Libre' }}
            >          Past Speakers
        </h2>
        {/* Speaker List Box */}
        <div data-component-id="src/app/NewSpeakersSection.tsx:56:8" data-component-path="src/app/NewSpeakersSection.tsx" data-component-line="56" data-component-file="NewSpeakersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1200px%5D%20mx-auto%22%7D" className="w-full max-w-[1200px] mx-auto">
          <div data-component-id="src/app/NewSpeakersSection.tsx:57:10" data-component-path="src/app/NewSpeakersSection.tsx" data-component-line="57" data-component-file="NewSpeakersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-2%20md%3Agrid-cols-3%20lg%3Agrid-cols-5%20gap-x-20%20gap-y-8%20sm%3Agap-3%20place-items-center%22%7D" className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-x-20 gap-y-8 sm:gap-3 place-items-center"> 
          {/* <div className="flex flex-wrap justify-center gap-5 sm:gap-10"> */}
            {speakers.map((speaker) => (  
              <div data-component-id="src/app/NewSpeakersSection.tsx:60:14" data-component-path="src/app/NewSpeakersSection.tsx" data-component-line="60" data-component-file="NewSpeakersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%20bg-%5B%23000%5D%20p-3%20rounded-%5B10px%5D%20%22%7D" key={speaker.name} className="flex flex-col items-center bg-[#000] p-3 rounded-[10px] ">  
                {/* Image Container */}
                <div data-component-id="src/app/NewSpeakersSection.tsx:62:16" data-component-path="src/app/NewSpeakersSection.tsx" data-component-line="62" data-component-file="NewSpeakersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-%5B120px%5D%20h-%5B120px%5D%20sm%3Aw-%5B200px%5D%20sm%3Ah-%5B200px%5D%20relative%20mb-4%22%7D" className="w-[120px] h-[120px] sm:w-[200px] sm:h-[200px] relative mb-4">  
                  <Image data-component-id="src/app/NewSpeakersSection.tsx:63:18" data-component-path="src/app/NewSpeakersSection.tsx" data-component-line="63" data-component-file="NewSpeakersSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-cover%22%7D"
                    src={speaker.imageSrc}
                    alt={speaker.alt}
                    fill={true}  
                    className="object-cover"
                    unoptimized
                  />
                </div>

                <h3 data-component-id="src/app/NewSpeakersSection.tsx:72:16" data-component-path="src/app/NewSpeakersSection.tsx" data-component-line="72" data-component-file="NewSpeakersSection.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-%5B%23cd1c80%5D%20text-%5B13px%5D%20sm%3Atext-%5B18px%5D%20font-semibold%20text-center%20mb-1%22%7D" className="text-[#cd1c80] text-[13px] sm:text-[18px] font-semibold text-center mb-1">
                  {speaker.name}
                </h3>
                <p data-component-id="src/app/NewSpeakersSection.tsx:75:16" data-component-path="src/app/NewSpeakersSection.tsx" data-component-line="75" data-component-file="NewSpeakersSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-%5B%23fff%5D%20text-%5B12px%5D%20sm%3Atext-%5B14px%5D%20text-center%20mb-1%22%7D" className="text-[#fff] text-[12px] sm:text-[14px] text-center mb-1">
                  {speaker.designation}
                </p>
                <p data-component-id="src/app/NewSpeakersSection.tsx:78:16" data-component-path="src/app/NewSpeakersSection.tsx" data-component-line="78" data-component-file="NewSpeakersSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-%5B%23fff%5D%20text-xs%20sm%3Atext-%5B12px%5D%20text-center%22%7D" className="text-[#fff] text-xs sm:text-[12px] text-center"> 
                  {speaker.company}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpeakerSection;
